import { FC, useEffect, useState } from "react";
import { useAuth } from "../Store/auth-context";
import { Schein } from "../Store/interfaces";
import { useScheinContext } from "../Store/schein-context";

interface ScheinListeProps {}

//Scheine Vom Kunden
const ScheinListe: FC<ScheinListeProps> = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { selectedCustomer, setSelectedCustomer } = useScheinContext();

  const [scheine, setScheine] = useState<Schein[]>([]);
  const { token } = useAuth();

  useEffect(() => {
    const url = `https://qas.freyadv.de/eserviceschein/snrs/kdnr/${selectedCustomer.Kundennummer}`;
    console.log("searching: " + url);
    setScheine([]);
    const runSearch = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
            "Access-Control-Allow-Origin":
              "http://localhost:3000/serviceschein",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          },
        });

        // console.log("RES: " + response.status);
        if (response.status !== 200) {
          alert("Error " + response.status);
          return;
        }

        const resData = await response.json();
        if (resData && resData.length > 0) {
          //sessionStorage.setItem("letztessuchergebnis", JSON.stringify(resData));
          console.log("Anzahl Suchergebnisse: " + resData.length);

          // Correctly handling asynchronous operations within a loop
          for (const value of Object.values(resData)) {
            const scheinUrl = `https://qas.freyadv.de/eserviceschein/snrs/${value}`;
            const scheinResponse = await fetch(scheinUrl, {
              headers: {
                Authorization: `${token}`,
                "Content-Type": "application/json",
                Accept: "*/*",
                "Access-Control-Allow-Origin":
                  "http://localhost:3000/serviceschein",
                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
              },
            });

            const scheinData = await scheinResponse.json();
            const newSchein: Schein = {
              ...scheinData,
              datum: new Date(scheinData.datum), // Ensure the date is correctly parsed
            };
            setScheine((prevScheine) => [...prevScheine, newSchein]);
            // Do something with sch here
          }
        }
      } catch (err: any) {
        console.error("error", err.message);
      }
    };

    runSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCustomer]);

  return (
    <div className="flex flex-col items-center justify-center align-middle">
      <h2 className="text-blue_royal text-2xl m-1 p-10 w-full text-center">
        Servicescheine von {selectedCustomer.Kunde}
      </h2>

      {/* Container for the list and its header, setting the width */}
      <div className="w-3/4">
        {/* Header */}
        <div className="flex bg-gray-300 rounded-t-lg p-2 justify-start">
          <div className="mr-2 w-1/4 text-center font-semibold text-blue_royal">
            Datum
          </div>
          <div className="w-1/4 text-center font-semibold text-blue_royal">
            Bearbeiter
          </div>
          <div className="w-1/4 text-center font-semibold text-blue_royal">
            Positionen
          </div>
          <div className="w-1/4 text-center font-semibold text-blue_royal">
            Allg.Kommentar
          </div>
        </div>

        {/* List */}
        <div className="flex flex-col">
          {scheine.map((schein) => {
            return (
              <div
                key={schein.snr}
                className="flex bg-gray-200 rounded-lg p-2 justify-start"
              >
                <div className="mr-2 w-1/4 text-center">
                  {schein.datum.toLocaleDateString()}
                </div>
                <div className="w-1/4 text-center">{schein.bearbeiter}</div>
                <div className="w-1/4 text-center">{schein.pos.length}</div>
                <div className="w-1/4 text-center">{schein.kommentar}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ScheinListe;
